import { render, staticRenderFns } from "./CopeAssessmentList.vue?vue&type=template&id=c887fbbe&scoped=true"
import script from "./CopeAssessmentList.vue?vue&type=script&lang=js"
export * from "./CopeAssessmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c887fbbe",
  null
  
)

export default component.exports